(($, Drupal) => {
  Drupal.behaviors.slider = {
    attach: function attch(context) {
      $('.js-slider', context).once('slider').each((index, element) => {
        $(element).slick({
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          fade: true,
          draggable: false,
          speed: 1000,
        });
      });
    },
  };
})(jQuery, Drupal);
